import DefaultPropsHoC from '../Generic/DefaultPropsHoC';
import LoadingSpinner from './index';

const LoadingSingle = DefaultPropsHoC(LoadingSpinner, { size: '2x', className: '_sec_' });

export default LoadingSingle;
